import LocalizedStrings from 'localized-strings';

import { TeamMemberRole } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    invitationConfirmation: 'The invitation has been sent to {firstName}',
    price: {
      description:
        'An adjustment fee is applied at the time of your guest’s activation. Then €{extraSeatCost}/month (excl. tax).',
      included: 'Included',
      label: 'Price',
      perMonth: '€{extraSeatCost}/month (excl. tax)',
    },
    roles: {
      [TeamMemberRole.AccountHolder]: '',
      [TeamMemberRole.Admin]: 'Admin',
      [TeamMemberRole.Accountant]: 'Accountant',
      [TeamMemberRole.Employee]: 'Employee',
    },
    seatsLeft: 'Remaining accesses included in your offer',
    title: 'Review your request',
  },
  fr: {
    cancel: 'Annuler',
    invitationConfirmation: 'L’invitation a bien été envoyée à {firstName}',
    price: {
      description:
        'Des frais d’ajustement sont appliqués au moment de l’activation de votre invité·e. Puis {extraSeatCost} € HT / mois.',
      included: 'Inclus',
      label: 'Prix',
      perMonth: '{extraSeatCost} HT € / mois',
    },
    roles: {
      [TeamMemberRole.AccountHolder]: '',
      [TeamMemberRole.Admin]: 'Admin',
      [TeamMemberRole.Accountant]: 'Comptable',
      [TeamMemberRole.Employee]: 'Employé·e',
    },
    seatsLeft: 'Accès restants inclus dans votre offre',
    title: 'Vérifiez les informations',
  },
} as const);

export default locales;
